// 定义 SimpleDialogTrigger 自定义元素
class EasterDialogTrigger extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.pops = this.querySelectorAll(".exit-pop");
    this.videoEl = this.querySelector("[data-plyr-video]");
    // this.form = this.closest("form#easter-upload-form");

   
    // 获取对话框ID
    const dialogId = this.getAttribute("data-dialog-trigger");

    // 查找对话框元素
    let dialog = this.querySelector("easter-dialog");
    this.dialog = dialog;
    if (dialog) {
      dialog.setAttribute("id", dialogId);
    }

    // 如果还没有对话框内容，则创建
    if (!dialog) {
      dialog = document.querySelector(`#${dialogId}`);
      //  const mask = dialog.querySelector(".easter-dialog-mask")
      // // 点击遮罩层关闭对话框
      // mask.addEventListener('click', () => {
      //   this.closeDialog(dialog);
      // });
      // 添加点击事件监听
      this.addEventListener("click", () => {
        this.openDialog(dialog);
      });

      this.dialog = dialog;
    } else if (dialog) {
      // 确保对话框结构完整
      this.ensureDialogStructure(dialog);

      // 将对话框移动到body末尾（如果尚未移动）
      if (!dialog.movedToBody) {
        document.body.appendChild(dialog);
        dialog.movedToBody = true;
      }

      // 添加点击事件监听
      this.addEventListener("click", () => {
        this.openDialog(dialog);
      });
    }
    this.addEventListener("force-open", () => {
      this.openDialog(dialog);
    });
    // dialog
    //   .querySelector('button[type="submit"]')
    //   .addEventListener("click", (e) => {
    //     if (this.form) {
    //       this.form.submit();
    //     }
    //   });
  }

  // 确保对话框包含必要的结构元素
  ensureDialogStructure(dialog) {
    // 如果还没有遮罩层，则创建
    if (!dialog.querySelector(".easter-dialog-mask")) {
      const mask = document.createElement("div");
      const closeBtn = dialog.querySelector(".easter-dialog-close");
      mask.className = "easter-dialog-mask";
      dialog.insertBefore(mask, dialog.firstChild);

      // 点击遮罩层关闭对话框
      mask.addEventListener("click", () => {
        this.closeDialog(dialog);
      });
    }

    // 如果还没有关闭按钮，则创建
    if (!dialog.querySelector(".easter-dialog-close")) {
      const closeBtn = document.createElement("button");
      closeBtn.className = "easter-dialog-close";
      closeBtn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12 13.4142L0 1.41421L1.41421 0L13.4142 12L12 13.4142Z" fill="currentColor"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M9.38892e-05 12L12.0001 -6.18172e-08L13.4143 1.41421L1.41431 13.4142L9.38892e-05 12Z" fill="currentColor"/>
</svg>`;
      closeBtn.setAttribute("aria-label", "关闭对话框");

      // 将关闭按钮添加到内容区域
      const content = dialog.querySelector(".easter-dialog-content");
      if (content) {
        content.appendChild(closeBtn);
      } else {
        // 如果没有内容区域，则直接添加到对话框
        dialog.appendChild(closeBtn);
      }

      // 点击关闭按钮关闭对话框
      closeBtn.addEventListener("click", () => {
        this.closeDialog(dialog);
      });
    } else {
      dialog
        .querySelector(".easter-dialog-close")
        .addEventListener("click", () => {
          this.closeDialog(dialog);
        });
    }
  }

  // 打开对话框
  openDialog(dialog) {
    if (this.video) {
      this.video.play();
    } else {
 if (this.videoEl) {
      this.video = new Plyr(this.videoEl, {
        controls: [
          'play-large', // The large play button in the center
          // 'restart', // Restart playback
          // 'rewind', // Rewind by the seek time (default 10 seconds)
          'play', // Play/pause playback
          // 'fast-forward', // Fast forward by the seek time (default 10 seconds)
          'progress', // The progress bar and scrubber for playback and buffering
          'current-time', // The current time of playback
          'duration', // The full duration of the media
          'mute', // Toggle mute
          'volume', // Volume control
          // 'captions', // Toggle captions
          'settings', // Settings menu
          'pip', // Picture-in-picture (currently Safari only)
          'airplay', // Airplay (currently Safari only)
          // 'download', // Show a download button with a link to either the current source or a custom URL you specify in your options
          'fullscreen', // Toggle fullscreen
        ],
        loop: {
          active: false,
        },
        resetOnEnd: false,

        tooltips: {
          controls: false,
          seek: false,
        },
        youtube: {
          loop: 1,
          title: false,
          showinfo: 0,
          rel: 0,
        },
        muted: true,

      })
    }
    }
    dialog.classList.add("easter-dialog-open");
    document.body.style.overflow = "hidden"; // 防止背景滚动

    // 添加ESC键关闭功能
    const escHandler = (e) => {
      if (e.key === "Escape") {
        this.closeDialog(dialog);
        document.removeEventListener("keydown", escHandler);
      }
    };

    document.addEventListener("keydown", escHandler);
    dialog._escHandler = escHandler;

    // 将焦点设置到关闭按钮
    const closeBtn = dialog.querySelector(".easter-dialog-close");
    if (closeBtn) {
      // setTimeout(() => closeBtn.focus(), 100);
    }
  }

  // 关闭对话框
  closeDialog(dialog) {
    if (this.video) {
      this.video.pause();
    }
    if (this.classList.contains("third-party-prize")) {
      // 如果是第三方奖品，禁止关闭,打开留邮对话框
      dialog.querySelector("easter-dialog-trigger").click();
      return;
    }
    dialog.classList.remove("easter-dialog-open");
    document.body.style.overflow = ""; // 恢复背景滚动

    // 移除ESC键监听
    if (dialog._escHandler) {
      document.removeEventListener("keydown", dialog._escHandler);
      delete dialog._escHandler;
    }
    this.pops.forEach(pop => {
      pop.classList.remove("active");
    })

    // 将焦点返回到触发按钮
    this.focus();
    if (dialog.querySelector(".easter-result-content")) {
      document.querySelector(".easter-2026-spin-section").classList.add("loading");
      setTimeout(() => {
        window.location.reload();
      }, 300)
    }
  }
}

// 注册自定义元素
if (!customElements.get("easter-dialog-trigger")) {
  customElements.define("easter-dialog-trigger", EasterDialogTrigger);
}

// view more

document
  .querySelector(".easter-2026-rank-view-more")
  .addEventListener("click", function (e) {
    e.preventDefault();
    if (this.classList.contains("active")) {
      this.classList.remove("active");
      document
        .querySelectorAll(".easter-2026-rank-row:nth-child(n+5)")
        .forEach(function (el) {
          el.classList.remove("active");
        });
    } else {
      this.classList.add("active");
      document
        .querySelectorAll(".easter-2026-rank-row:nth-child(n+5)")
        .forEach(function (el) {
          el.classList.add("active");
        });
    }
  });
